import React from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';

import {default as Modal, withModal} from 'components/Modal';
import Button from 'components/Button';
import Loader from 'components/Loader';
import ErrorBlock from 'components/ErrorBlock';

import {isModalOpen, MODALS, selectModal} from 'ducks/modals';

import './styles.css';

const XlsxExportModal = ({
  closeModal,
  isOpen,
  heading,
  message,
  errors,
  processing
}: any) => {
  const closeHandler = () => {
    if (processing) {
      return () => {};
    }
    return closeModal;
  };

  return (
    <Modal
      className="XlsxExportModal"
      modalOverlayClassName="XlsxExportModalOverlay"
      show={isOpen}
      type={Modal.EXTRA_SMALL}
      onClose={closeHandler()}>
      <Modal.Header heading={heading} />
      <Modal.Body>
        {errors && <ErrorBlock>{errors}</ErrorBlock>}
        {processing && <Loader />}
        {!processing && (
          <p className="successMessage">
            {message || 'Export finished. You can now close the modal.'}
          </p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button white onClick={closeHandler()} disabled={processing}>
          Okay
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const mapStateToProps = state => {
  const modal = selectModal(state, MODALS.XLSX_EXPORT_MODAL);

  return {
    isOpen: isModalOpen(state, MODALS.XLSX_EXPORT_MODAL),
    heading: _.get(modal, 'data.heading'),
    message: _.get(modal, 'data.message'),
    errors: _.get(modal, 'data.errors'),
    processing: _.get(modal, 'data.processing')
  };
};

export default connect(mapStateToProps)(
  withModal(MODALS.XLSX_EXPORT_MODAL)(XlsxExportModal)
);
